<template>
  <div class="panel-body">
    <div class="row panel-heading">
      <div class="col-sm-12">
        <div class="pull-right">
          <form class="form-inline search-fields" @submit.prevent="form.onSearch">
            <div class="form-group">
              <select class="form-control" id="searchField" name="searchField" v-model="form.search.field">
                <option value="date" v-if="showDate">{{fields['date']}}</option>
                <option v-for="field in showFields" v-bind:value="field">{{fields[field]}}</option>
              </select>
            </div>
            <div class="input-group">
              <input type="search" placeholder="search" class="form-control" v-model="form.search.term" v-if="form.search.field !== 'date'">
              <datepicker v-model="form.search.date" format="yyyy-MM-dd" input-class="form-control" v-if="form.search.field === 'date'"></datepicker>
              <span class="input-group-addon pointer" v-on:click="form.onSearch()" title="search"><i class="fa fa-search"></i></span>
            </div>
            <a class="pointer" v-on:click="form.clearSearch()" title="clear search"><i class="fa fa-times"></i></a>
            <div class="panel-note" v-if="showDraggableHint">Filter by zone to enable route ordering</div>
          </form>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import _ from 'lodash';

  export default {
    name: 'search-fields',

    props: ['form', 'fields', 'showDraggableHint'],

    components: {
      Datepicker
    },

    computed: {
      showDate() {
        return _.includes(Object.keys(this.fields), 'date');
      },
      showFields() {
        return _.filter(Object.keys(this.fields), (o) => { return o != 'date';  });
      }
    },

    mounted() {
      this.$props.form.search.field = Object.keys(this.fields)[0];
    }

  }


</script>
